import React, { Component } from "react";
import { Form, FormGroup, Card, CardBody, Button, Col, Row } from "reactstrap";
import "./mobileuser.css";
import axios from "axios";
import Swal from "sweetalert2";
import { configuration } from "../../../appConfig";
import { Modal, ModalBody, ModalFooter, ModalHeader } from "reactstrap";

const Toast = Swal.mixin({
    toast: true,
    position: "top-end",
    showConfirmButton: false,
    timer: 3000,
});

class mobileUser extends Component {
    constructor(props) {
        super(props);

        this.state = {
            firstName: "",
            lastName: "",
            email_id: "",
            mobileNo: "",
            password: "",
            location: "",
            isActive: "",

            partnerId: "",
            mobile_user_id: "",

            showPassword: false,
            showPassword1: false,

            confirmPassword: "",
            errors: [],
            mobileUsers: [],
            searchStatus: false,
            perPageRecords: 10,

            current_page: 1,
            next_page: 2,
            prev_page: null,

            loader: false,
            activeTab: "add-mobileuser-details-tab",

            showUserUpdatePassword: false,
            showUserUpdateConfirmPassword: false,

            updateFirstName: "",
            updateLastName: "",
            updateEmailID: "",
            updateMobileNo: "",
            updateIsActive: "",
            updateLocation: "",
            updateMobileUserId: "",
            disableEdit: true,

            modal: false,
            passModal: false,
            newPassword: "",
            newConfirmPassword: "",
            userMobileUserId: "",
            userEmail: "",
        }
        // this.handleFilterChange = this.handleFilterChange.bind(this);
    }


    componentDidMount() {
        this.showMobileUsers();
        this.setState({
            activeTab: localStorage.getItem("activeTab") || "add-mobileuser-details-tab",
        })
    }

    handleTab = (tabId) => {
        this.setState({ activeTab: tabId, })
        localStorage.setItem("activeTab", tabId);
    }


    //SHOW & HIDE PASSWORD
    handleToggleShowPassword = () => {
        this.setState({ showPassword: !this.state.showPassword });
    };
    handleToggleShowPassword1 = () => {
        this.setState({ showPassword1: !this.state.showPassword1 });
    };


    onChange = (event) => {
        const { name, value } = event.target;
        const trimmedValue = value.trim();
        this.setState({ [name]: trimmedValue });
    };

    handleKeyDown = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();
        }
    };


    onSubmit = async (e) => {
        e.preventDefault();
        const partnerId = localStorage.getItem("partnerId")
        const {
            firstName,
            lastName,
            email_id,
            password,
            mobileNo,
            location,
            confirmPassword,
            mobile_user_id,

        } = this.state;

        //VALIDATION
        var emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const errors = [];

        if (firstName === "") { errors.push("First name is required."); }
        if (lastName === "") { errors.push("Last name is required."); }
        if (email_id === "") { errors.push("Email ID is required."); }
        if (!emailPattern.test(email_id)) { errors.push("Please enter a valid Email address."); }
        if (password === "") { errors.push("Password is required."); }

        if (confirmPassword === "") { errors.push("Confirm Password is required."); }
        else if (password !== confirmPassword) { errors.push("Passwords do not match."); }
        else if (password.length < 5) { errors.push("Password must be at least 5 characters long."); }

        if (errors.length) { this.setState({ errors }); } else {
            this.setState({ errors: [], loader: true });

            let payload = {
                partner_id: partnerId,
                first_name: firstName,
                last_name: lastName,
                email: email_id,
                password: password,
                mobile_no: mobileNo,
                location: location,
                is_active: "1",
                mobile_userid: mobile_user_id,
            };
            try {
                const res = await axios.post(configuration.createMobileUser, payload);

                if (res.status === 200) {
                    Toast.fire({
                        type: "success", title: "Created successfully",
                    });
                    this.setState(
                        {
                            activeTab: "mobileuser-list-details-tab",
                            firstName: "",
                            lastName: "",
                            email_id: "",
                            password: "",
                            mobileNo: "",
                            confirmPassword: "",
                            loader: false,
                        },
                        () => {
                            localStorage.setItem("activeTab", "mobileuser-list-details-tab");
                            this.showMobileUsers();

                            // window.open("https://drivenscan.de/", "_blank")

                        });

                } else if (res.data.status == false && res.data.status == 400) {
                    alert("else")
                    Toast.fire({
                        type: "error",
                        title: "Else error occurred.",
                    });
                    this.setState({ loader: false });
                }
            } catch (err) {
                Toast.fire({
                    type: "error",
                    title: "An error occurred.",
                });
                this.setState({ loader: false });
            }
        }
    }

    //Show list in list tab 
    showMobileUsers = async (page_no = 1, searchValue = "", perPageRecords = 10) => {
        const partnerId = localStorage.getItem("partnerId")
        try {
            let url = `${configuration.listMobileUser}?partner_id=${partnerId}&page_no=${page_no}`;

            if (searchValue) {
                url += `&search=${searchValue}`;
            }

            if (perPageRecords !== 10) {
                url += `&per_page_record=${perPageRecords}`;
            }

            const res = await axios.get(url)

            if (res.status === 200) {
                const apiUsers = res.data.data.latest_mobile_user_id;

                var parts = apiUsers.split('.');
                var nextValue = parseFloat(parts[1]) + 1;

                const newMobileUserId = parts[0] + '.' + nextValue;

                this.setState({
                    mobileUsers: res.data.data.list,
                    mobile_user_id: newMobileUserId,
                    searchStatus: searchValue !== "",
                    current_page: res.data.data.current_page,
                    next_page: res.data.data.next_page,
                    prev_page: res.data.data.prev_page,
                    perPageRecords: res.data.data.per_page_record,
                    total_page: res.data.data.total_page,
                });
            }
        } catch (error) {
            console.error("Error fetching mobile users", error);
            this.setState({
                searchStatus: true,
            })
        }
    }

    //DELETE
    deleteMobileUser = (mobile_user_id) => {
        Swal.fire({
            title: "Are you sure?",
            text: "You are able to revert this!",  // Updated static text
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#3085D6",
            cancelButtonColor: "#d33",
            confirmButtonText: "Yes",
            cancelButtonText: "No",
        }).then((result) => {
            if (result.value) {
                const url = configuration.deleteMobileUser;

                const payload = {
                    mu_id: mobile_user_id,
                };

                axios.post(url, payload).then((res) => {
                    if (res.data.success) {
                        Swal.fire("Success", res.data.message, "success");
                        this.showMobileUsers("1");
                    } else {
                        Swal.fire("Error!", "There was an issue deleting the User.", "error")
                    }
                });
            }
        });
    }

    //CHANGE PASSWORD

    changePasswordClick = (userId) => {
        this.setState({
            passModal: !this.state.passModal,
            userId: userId,
            newPassword: "",
            newConfirmPassword: ""
        })
    }

    changePasswordChange = (event) => {
        const { name, value } = event.target;
        this.setState({ [name]: value });
    };

    changePassword = async () => {
        const { userId, newPassword, newConfirmPassword } = this.state;

        const errors = [];
        if (newConfirmPassword === "") { errors.push("Confirm Password is required."); }
        else if (newPassword !== newConfirmPassword) { errors.push("Passwords do not match."); }
        else if (newPassword.length < 5) { errors.push("Password must be at least 5 characters long."); }

        if (errors.length) { this.setState({ errors }); } else {
            this.setState({ errors: [], loader: true });

            const payload = {
                mu_id: userId,
                password: newPassword,
                confirm_password: newConfirmPassword,
            }

            try {
                const res = await axios.post(configuration.changeMobilePassword, payload);
                if (res.status === 200) {
                    Toast.fire({
                        type: "success",
                        title: "Password changed successfully.",
                    })
                    this.changePasswordClick();
                } else {
                    Toast.fire({
                        type: "error",
                        title: "Failed to change password.",
                    });
                }
            } catch (err) {
                Toast.fire({
                    type: "error",
                    title: "An error occurred.",
                })
            }
        }
    }

    //UPDATE

    togglePasswordVisibility = (e, key) => {
        e.preventDefault();
        this.setState((prevState) => ({
            [key]: !prevState[key],
        }));
    };

    updateMobileUserClick = (user) => {
        this.setState({
            modal: true,
            updateMobileUserId: user.mobile_user_id,
            updateFirstName: user.first_name,
            updateLastName: user.last_name,
            updateEmailID: user.email_id,
            updateMobileNo: user.mobile_no,
        });
    };

    updateMobileUserChange = (event) => {
        const { name, value } = event.target;
        const trimmedValue = value.trim();
        this.setState({ [name]: trimmedValue });
    }

    updateMobileUser = async (e) => {
        e.preventDefault();

        const partnerId = localStorage.getItem("partnerId")
        const {
            updateMobileUserId,
            updateFirstName,
            updateLastName,
            updateEmailID,
            updateMobileNo,
            current_page,
        } = this.state;

        var updateEmailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const errors = [];

        if (updateFirstName === "") { errors.push("First name is required."); }
        if (updateLastName === "") { errors.push("Last name is required."); }
        if (updateEmailID === "") { errors.push("Email ID is required."); }
        if (!updateEmailPattern.test(updateEmailID)) { errors.push("Please enter a valid Email address."); }

        if (errors.length) { this.setState({ errors: errors, }); } else {
            this.setState({ errors: [], loader: true });

            let payload = {
                partner_id: partnerId,
                mobile_userid: updateMobileUserId,
                first_name: updateFirstName,
                last_name: updateLastName,
                email: updateEmailID,
                mobile_no: updateMobileNo,
                is_active: "1",
            };
            try {
                const res = await axios.post(configuration.createMobileUser, payload);

                if (res.status === 200) {
                    Toast.fire({
                        type: "success",
                        title: `${updateMobileUserId} Upadate successfully.`,
                    });

                    this.setState({
                        modal: false,
                        // updateMobileUserId: res.data.mobile_userid,
                        loader: false,
                    });
                    this.showMobileUsers(current_page);
                } else if (res.data.status === 400) {
                    errors.push("Error.");
                    if (errors.length) {
                        this.setState({
                            errors: errors,
                            loader: false
                        });
                    }
                }
            }
            catch (err) {
                Toast.fire({
                    type: "error",
                    title: "An error occurred.",
                });
                this.setState({ modal: false, });
            };
        }
    };

    closeModal = () => {
        this.setState({
            modal: false,
            disableEdit: true,
        });
    };


    //SEARCH INPUT CHANGE
    handleSearchInputChange = (e) => {
        this.setState({
            [e.target.name]: e.target.value,
        });

        if (e.target.value.trim() === "") {
            this.setState(
                {
                    result: [],
                    searchStatus: false,
                },
                () => this.showMobileUsers("1")
            );
        }
    }

    calculateNewPage = (currentPage, oldPerPageRecords, newPerPageRecords) => {
        const currentStartIndex = (currentPage - 1) * oldPerPageRecords;
        return Math.floor(currentStartIndex / newPerPageRecords) + 1;
    };


    handleFilterChange = (e) => {
        const { name, value } = e.target;
        console.log(name, value);

        const { current_page, perPageRecords, searchUser } = this.state;

        const newPerPageRecords = parseInt(value, 10);
        console.log(newPerPageRecords);

        const newPage = this.calculateNewPage(
            current_page,
            perPageRecords,
            newPerPageRecords
        );

        this.setState(
            {
                [name]: newPerPageRecords,
                current_page: newPage,
            },
            () => {
                this.showMobileUsers(newPage, searchUser, newPerPageRecords);
            }
        );
    };


    render() {
        const {
            firstName,
            lastName,
            email_id,
            password,
            mobileNo,
            showPassword,
            showPassword1,
            confirmPassword,
            errors,
            current_page,
            prev_page,
            next_page,
            loader,
            searchStatus,
            searchUser,
            perPageRecords,
            activeTab,
            mobileUsers,
            mobile_user_id,
            updateMobileUserId,
            updateFirstName,
            updateLastName,
            updateEmailID,
            updateMobileNo,
            showUserUpdatePassword,
            showUserUpdateConfirmPassword,
            disableEdit,

        } = this.state;

        return (
            <>
                <div className="mobile_user_main_wrapper">
                    <Row className="justify-content-center">
                        <Col xl={10} lg={11} md={12} sm={12}>
                            <ul
                                className="nav nav-pills mb-0"
                                id="user-profile-wrapper"
                                role="tablist"
                            >
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${activeTab === "add-mobileuser-details-tab" ? "active" : ""}`}
                                        id="add-mobileuser-details-tab" data-bs-toggle="pill" data-bs-target="#add-mobileuser-details"
                                        type="button" role="tab" aria-controls="add-mobileuser-details"
                                        aria-selected={activeTab === "add-mobileuser-details-tab"}
                                        onClick={() => this.handleTab("add-mobileuser-details-tab")}
                                    >
                                        Add Mobile User
                                    </button>
                                </li>
                                <li className="nav-item" role="presentation">
                                    <button
                                        className={`nav-link ${activeTab === "mobileuser-list-details-tab" ? "active" : ""}`}
                                        id="mobileuser-list-details-tab" data-bs-toggle="pill" data-bs-target="#mobileuser-list-details"
                                        type="button" role="tab" aria-controls="mobileuser-list-details"
                                        aria-selected={activeTab === "mobileuser-list-details-tab"}
                                        onClick={() => this.handleTab("mobileuser-list-details-tab")}
                                    >
                                        Mobile User List
                                    </button>
                                </li>
                            </ul>
                            <div className="tab-content" id="user-profile-wrapperContent">
                                <div
                                    className={`tab-pane fade ${activeTab === "add-mobileuser-details-tab" ? "show active" : ""}`}
                                    id="add-mobileuser-details"
                                    role="tabpanel"
                                    aria-labelledby="add-mobileuser-details-tab"
                                >
                                    <Card className="mobile_user_card">
                                        <CardBody>
                                            <form>
                                                <div className="row">
                                                    <div className="col-lg-12 col-md-12 col-sm-12">
                                                        <div className="form-group mobile_user_input">
                                                            <label>Mobile User ID</label>
                                                            <input type="text" className="form-control" name="mobile_user_id" disabled value={mobile_user_id || "loading"} />
                                                        </div>
                                                    </div>
                                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                                        <div className="form-group mobile_user_input">
                                                            <label>First Name</label>
                                                            <input type="text" className="form-control" name="firstName" value={firstName} onChange={this.onChange} placeholder="First Name" />
                                                            {errors.includes("First name is required.") && (
                                                                <span style={{ color: "red" }}>First name is required.</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                                        <div className="form-group mobile_user_input">
                                                            <label>Last Name</label>
                                                            <input type="text" className="form-control" name="lastName" value={lastName} onChange={this.onChange} placeholder="Last Name" />
                                                            {errors.includes("Last name is required.") && (
                                                                <span style={{ color: "red" }}>Last name is required.</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                                        <div className="form-group mobile_user_input">
                                                            <label>E-mail address</label>
                                                            <input type="email" className="form-control" name="email_id" value={email_id} onChange={this.onChange} placeholder="E-mail address" />
                                                            {errors.includes("Email ID is required.") && (
                                                                <span style={{ color: "red" }}>Email ID is required.</span>
                                                            )}
                                                            {errors.includes("Please enter a valid Email address.") &&
                                                                !errors.includes("Email ID is required.") && (
                                                                    <span style={{ color: "red" }}>Please enter a valid Email address.</span>
                                                                )}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                                        <div className="form-group mobile_user_input">
                                                            <label>Mobile Number</label>
                                                            <input type="tel" className="form-control" name="mobileNo" value={mobileNo} onChange={this.onChange} placeholder="Mobile Number" />
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                                        <div className="form-group mobile_user_input">
                                                            <label>Password</label>
                                                            <div className="position-relative">
                                                                <input type={showPassword ? "text" : "password"} className="form-control" name="password" value={password} onChange={this.onChange} placeholder="Password" />
                                                                <div className="password-icon" onClick={this.handleToggleShowPassword}                                                            >
                                                                    <i className={showPassword ? "fa fa-eye" : "fa fa-eye-slash"}></i>
                                                                </div>
                                                            </div>
                                                            {errors.includes("Password is required.") && (
                                                                <span style={{ color: "red" }}>Password is required.</span>
                                                            )}
                                                            {errors.includes("Password must be at least 5 characters long.") && (
                                                                <span style={{ color: "red" }}>Password must be at least 5 characters long.</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                                        <div className="form-group mobile_user_input">
                                                            <label>Confirm Password</label>
                                                            <div className="position-relative">
                                                                <input type={showPassword1 ? "text" : "password"} className="form-control" name="confirmPassword" value={confirmPassword} onChange={this.onChange} placeholder="Password" />
                                                                <div className="password-icon" onClick={this.handleToggleShowPassword1}>
                                                                    <i className={showPassword1 ? "fa fa-eye" : "fa fa-eye-slash"}></i>
                                                                </div>
                                                            </div>
                                                            {errors.includes(
                                                                "Confirm Password is required.") && (
                                                                    <span style={{ color: "red" }}>Confirm Password is required.</span>
                                                                )}
                                                            {errors.includes("Passwords do not match.") && (
                                                                <span pan style={{ color: "red" }}>Passwords do not match.</span>
                                                            )}
                                                        </div>
                                                    </div>

                                                    <div className="col-12">
                                                        <div className="form-group mobile_user_input">
                                                            <button type="button " className="btn pull-right theme_button" onClick={this.onSubmit} disabled={loader}>
                                                                {loader ? (
                                                                    <div className="text-center">
                                                                        <div className="spinner-border" role="status">
                                                                            <span className="sr-only">Loading...</span>
                                                                        </div>
                                                                    </div>
                                                                ) : (
                                                                    ("Create Mobile User")
                                                                )}
                                                            </button>
                                                        </div>
                                                    </div>
                                                </div>
                                            </form>
                                        </CardBody>
                                    </Card>
                                </div>


                                <div
                                    className={`tab-pane fade ${activeTab === "mobileuser-list-details-tab" ? "show active" : ""}`}
                                    id="mobileuser-list-details"
                                    role="tabpanel"
                                    aria-labelledby="mobileuser-list-details-tab"
                                >
                                    <Card className="mobile_user_card">
                                        <CardBody>
                                            <div className='row mobileuser_search_main_wrapper mt-2 justify-content-between'>
                                                <div className="col-lg-2 col-md-3 col-sm-12">
                                                    <div className="form-group mb-0">
                                                        <select
                                                            className="form-control"
                                                            name='perPageRecords'
                                                            onChange={(e) => this.handleFilterChange(e)}
                                                            value={this.state.perPageRecords}
                                                        >
                                                            {[10, 20, 30, 40, 50, 60, 70, 80, 90, 100].map((value, index) => (
                                                                <option key={index} value={value}>{value}</option>
                                                            ))}
                                                        </select>
                                                    </div>
                                                </div>

                                                <div className="col-lg-4 col-md-6 col-sm-12">
                                                    <div className='form-group mb-0'>
                                                        <input type="text" name="searchUser" className="form-control" placeholder="Search"
                                                            value={this.state.searchUser}
                                                            onChange={(e) => this.handleSearchInputChange(e)}
                                                            onKeyPress={(e) => {
                                                                if (e.key === "Enter") {
                                                                    this.showMobileUsers("1", searchUser, perPageRecords);
                                                                }
                                                            }}
                                                        />
                                                    </div>

                                                    {searchStatus && searchUser && searchUser.trim() && (
                                                        <button className="close_button main_close__search"
                                                            onClick={() => {
                                                                this.setState({ searchUser: "" },
                                                                    () => this.showMobileUsers("1"))
                                                            }}>
                                                            <i className="fa fa-close"></i>
                                                        </button>
                                                    )}

                                                    <button
                                                        className="search_icon_button"
                                                        onClick={() => {
                                                            this.showMobileUsers("1", searchUser, perPageRecords);
                                                        }}>
                                                        <i className="fa fa-search"></i>
                                                    </button>

                                                </div>
                                            </div>
                                            <div className="row mt-0">
                                                <div className="col-lg-12 col-md-12 col-sm-12">
                                                    <div className="table-responsive">
                                                        <table className="table table-bordered">
                                                            <thead>
                                                                <tr>
                                                                    <th className="text-center">Sr. No.</th>
                                                                    <th>Mobile User ID</th>
                                                                    <th>First & Last name</th>
                                                                    <th>E-mail address</th>
                                                                    <th>Mobile Number</th>
                                                                    <th className="text-center">Status</th>
                                                                    <th className="text-center">Action</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {mobileUsers.length === 0 ? (
                                                                    <tr><td colSpan="7" className="text-center"> No users found</td></tr>
                                                                ) : (
                                                                    mobileUsers.map((user, index) => (
                                                                        <tr key={index}
                                                                            className={`order-status-row text-center ${user.is_active === "1" ? "active" : "deactive"}`}
                                                                        // style={{ textDecoration: user.is_active === "0" ? "line-through" : "none" }}
                                                                        >

                                                                            <td className="text-center">
                                                                                {(current_page - 1) * (perPageRecords ? parseInt(perPageRecords) : 10) + index + 1}
                                                                            </td>
                                                                            <td>{user.mobile_user_id}</td>
                                                                            <td>{user.first_name} {user.last_name}</td>
                                                                            <td>{user.email_id}</td>
                                                                            <td>{user.mobile_no}</td>
                                                                            <td className={`order-status-row text-center ${user.is_active === "1" ? "active" : "deactive"}`}>
                                                                                {user.is_active === "1" ? "Active" : "Deactive"}
                                                                            </td>

                                                                            <td>
                                                                                <div className='text-center'>
                                                                                    <button className='edit_btn' style={{ color: user.is_active === "0" ? "#786969" : "#d80707" }}
                                                                                        disabled={user.is_active === "0"}
                                                                                        onClick={() => { this.updateMobileUserClick(user) }}>
                                                                                        <i className='fa fa-pencil'></i>
                                                                                    </button>
                                                                                    <button className='edit_btn' style={{ color: user.is_active === "0" ? "#786969" : "#d80707" }}
                                                                                        disabled={user.is_active === "0"}
                                                                                        onClick={() => { this.changePasswordClick(user.id) }}>
                                                                                        <i className='fa fa-key'></i>
                                                                                    </button>
                                                                                    <button
                                                                                        className={user.is_active === "0" ? 'deactive_btn' : 'active_btn'}
                                                                                        // style={{ color: user.is_active === "0" ? "#786969" : "#d80707" }}
                                                                                        onClick={() => { this.deleteMobileUser(user.mobile_user_id) }}
                                                                                    >
                                                                                        <i className={user.is_active === "0" ? 'fa fa-times' : 'fa fa-check'}></i>
                                                                                    </button>
                                                                                </div>
                                                                            </td>
                                                                        </tr>
                                                                    )
                                                                    ))}
                                                            </tbody>
                                                        </table>

                                                        <div className="text-right qr_table_footer">
                                                            <div className="row justify-content-end">
                                                                <div className="col-lg-5 col-md-6 col-sm-12">
                                                                    <nav aria-label="Page navigation example">
                                                                        <ul className="pagination justify-content-end">
                                                                            <>
                                                                                <li className="page-item disabled">
                                                                                    <button className="btn"
                                                                                        disabled={prev_page === null}
                                                                                        onClick={() => this.showMobileUsers(prev_page, searchUser, perPageRecords)}
                                                                                    >
                                                                                        <i className="fa fa-angle-double-left" aria-hidden="true"></i>
                                                                                    </button>
                                                                                </li>

                                                                                {prev_page && (
                                                                                    <li className="page-item">
                                                                                        <button className="btn" onClick={() => this.showMobileUsers(prev_page)}>
                                                                                            {prev_page}
                                                                                        </button>
                                                                                    </li>
                                                                                )}

                                                                                <li className="page-item active">
                                                                                    {current_page != undefined || current_page != null ? (
                                                                                        <button className="btn" onClick={() => this.showMobileUsers(current_page)}>
                                                                                            {current_page === null ? 1 : current_page}
                                                                                        </button>
                                                                                    ) : (
                                                                                        ""
                                                                                    )}
                                                                                </li>

                                                                                {next_page && (
                                                                                    <li className="page-item" onClick={() => this.showMobileUsers(next_page)}>
                                                                                        <button className="btn">{next_page}</button>
                                                                                    </li>
                                                                                )}

                                                                                <li className="page-item">
                                                                                    <button className="btn" disabled={next_page === null} onClick={() => this.showMobileUsers(next_page, searchUser, perPageRecords)}>
                                                                                        <i className="fa fa-angle-double-right" aria-hidden="true"></i>
                                                                                    </button>
                                                                                </li>
                                                                            </>
                                                                        </ul>
                                                                    </nav>
                                                                </div>
                                                            </div>
                                                        </div>

                                                    </div>
                                                </div>
                                            </div>
                                        </CardBody>
                                    </Card>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </div >


                {/* UPDATE MODAL */}

                <Modal centered={true} size="xl" isOpen={this.state.modal} className="theme_modal_user" backdrop="static" toggle={() => this.setState({ modal: false })}>

                    <ModalHeader toggle={() => this.setState({ modal: false, errors: [] })} className="p-3">
                        Update Mobile User
                    </ModalHeader>

                    <form>
                        <ModalBody>
                            <div>
                                <div className="row p-0">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="mb-3 form-group">
                                            <label for="exampleInputEmail1" className="form-label"> Moble User ID </label>
                                            <input
                                                type="text"
                                                className="form-control"
                                                disabled
                                                name="updateMobileUserId"
                                                value={updateMobileUserId}
                                            />
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="mb-3 form-group">
                                            <label for="exampleInputEmail1" className="form-label">First Name</label>
                                            <input type="text" className="form-control" name="updateFirstName" value={updateFirstName}
                                                onChange={this.updateMobileUserChange} placeholder="First Name" />

                                            {errors.includes("First name is required.") && (
                                                <span style={{ color: "red" }}>First name is required.</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="mb-3 form-group">
                                            <label for="exampleInputEmail1" className="form-label">Last Name</label>
                                            <input type="text" className="form-control" name="updateLastName" value={updateLastName}
                                                onChange={this.updateMobileUserChange} placeholder="Last Name" />

                                            {errors.includes("Last name is required.") && (
                                                <span style={{ color: "red" }}>Last name is required.</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="mb-3 form-group">
                                            <label for="EmailAddressInput" className="form-label"> Email ID </label>
                                            <input type="email" className="form-control" name="updateEmailID" value={updateEmailID}
                                                onChange={this.updateMobileUserChange} placeholder="E-mail address" />

                                            {errors.includes("Email ID is required.") && (
                                                <span style={{ color: "red" }}>Email ID is required.</span>
                                            )}
                                            {errors.includes("Please enter a valid Email address.") &&
                                                !errors.includes("Email ID is required.") && (
                                                    <span style={{ color: "red" }}>Please enter a valid Email address.</span>
                                                )}
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="mb-3 form-group">
                                            <label for="exampleInputEmail1" className="form-label">Mobile No</label>
                                            <input type="tel" className="form-control" name="updateMobileNo" value={updateMobileNo}
                                                onChange={this.updateMobileUserChange} placeholder="Mobile Number" />
                                        </div>
                                    </div>


                                    {/* <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="mb-3 form-group">
                                            <div className="position-relative">
                                                <label for="PasswordInput" className="form-label"> Password </label>
                                                <input
                                                    type={showUserUpdatePassword ? "text" : "password"}
                                                    className="form-control"
                                                    name="updatePassword"
                                                    value={updatePassword}
                                                    onChange={this.updateMobileUserChange}
                                                    onKeyDown={this.handleKeyDown}
                                                    placeholder="Password"
                                                />
                                                <div className="password_button">
                                                    <button className="btn"
                                                        onClick={(e) => this.togglePasswordVisibility(e, "showUserUpdatePassword")}>

                                                        <i className={`fa ${showUserUpdatePassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                                                    </button>
                                                </div>
                                            </div>
                                            {errors.includes("Password must be at least 5 characters long.") && (
                                                <span style={{ color: "red" }}>Password must be at least 5 characters long.</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="mb-3 form-group">
                                            <div className="position-relative">
                                                <label for="ConfirmPasswordInput" className="form-label"> Confirm Password </label>
                                                <input
                                                    type={showUserUpdateConfirmPassword ? "text" : "password"}
                                                    className="form-control"
                                                    name="updateConfirmPassword"
                                                    value={updateConfirmPassword}
                                                    onChange={this.updateMobileUserChange}
                                                    onKeyDown={this.handleKeyDown}
                                                    placeholder="Confirm Password"
                                                />
                                                <div className="password_button">
                                                    <button className="btn"
                                                        onClick={(e) => this.togglePasswordVisibility(e, "showUserUpdateConfirmPassword")}>

                                                        <i className={`fa ${showUserUpdateConfirmPassword ? "fa-eye" : "fa-eye-slash"}`} ></i>
                                                    </button>
                                                </div>

                                            </div>
                                            {errors.includes("Passwords do not match.") && (
                                                <span pan style={{ color: "red" }}>Passwords do not match.</span>
                                            )}
                                        </div>
                                    </div> */}
                                </div>
                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <div>
                                <button className="btn btn-md p-2 mr-2 cancel_btn"
                                    onClick={(e) => {
                                        e.preventDefault();
                                        this.setState({
                                            modal: false, errors: [], updatePassword: "", updateConfirmPassword: "",
                                        });
                                    }}
                                >
                                    cancel
                                </button>

                                <button className="btn btn-md p-2 submit_button" onClick={(e) => this.updateMobileUser(e)}>
                                    Update
                                </button>
                            </div>
                        </ModalFooter>
                    </form>
                </Modal>

                {/* CHANGE PASSWORD MODAL */}

                <Modal centered={true} size="xl" isOpen={this.state.passModal} className="theme_modal_user" backdrop="static" toggle={this.changePasswordClick}>
                    <ModalHeader toggle={this.changePasswordClick} className="p-3">Change Password</ModalHeader>
                    <form>
                        <ModalBody>
                            <div>
                                <div className="row p-0">
                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="mb-3 form-group">
                                            <div className="position-relative">
                                                <label for="PasswordInput" className="form-label">New Password</label>
                                                <input
                                                    type={showUserUpdatePassword ? "text" : "password"}
                                                    name="newPassword"
                                                    value={this.state.newPassword}
                                                    onChange={this.changePasswordChange}
                                                    className="form-control"
                                                    onKeyDown={this.handleKeyDown}
                                                    placeholder="Password"
                                                />
                                                <div className="password_button">
                                                    <button className="btn"
                                                        onClick={(e) => this.togglePasswordVisibility(e, "showUserUpdatePassword")}>

                                                        <i className={`fa ${showUserUpdatePassword ? "fa-eye" : "fa-eye-slash"}`}></i>
                                                    </button>
                                                </div>
                                            </div>
                                            {errors.includes("Password must be at least 5 characters long.") && (
                                                <span style={{ color: "red" }}>Password must be at least 5 characters long.</span>
                                            )}
                                        </div>
                                    </div>

                                    <div className="col-lg-6 col-md-6 col-sm-12">
                                        <div className="mb-3 form-group">
                                            <div className="position-relative">
                                                <label for="ConfirmPasswordInput" className="form-label">Confirm New Password</label>
                                                <input
                                                    type={showUserUpdateConfirmPassword ? "text" : "password"}
                                                    name="newConfirmPassword"
                                                    value={this.state.newConfirmPassword}
                                                    onChange={this.changePasswordChange}
                                                    className="form-control"
                                                    onKeyDown={this.handleKeyDown}
                                                    placeholder="Confirm Password"
                                                />
                                                <div className="password_button">
                                                    <button className="btn"
                                                        onClick={(e) => this.togglePasswordVisibility(e, "showUserUpdateConfirmPassword")}>

                                                        <i className={`fa ${showUserUpdateConfirmPassword ? "fa-eye" : "fa-eye-slash"}`} ></i>
                                                    </button>
                                                </div>
                                            </div>
                                            {errors.includes("Passwords do not match.") && (
                                                <span pan style={{ color: "red" }}>Passwords do not match.</span>
                                            )}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </ModalBody>

                        <ModalFooter>
                            <Button className="btn btn-md p-2 submit_button" onClick={this.changePassword}>Change Password</Button>
                            <Button className="btn btn-md p-2 mr-2 cancel_btn" color="secondary" onClick={this.changePasswordClick}>Cancel</Button>
                        </ModalFooter>
                    </form>
                </Modal>

            </>
        )
    }
}
export default mobileUser;